import {
  faEdit,
  faFolder,
  faStickyNote,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Card, CardBody, CardFooter, Col, Row } from 'reactstrap'
import { deleteFile } from 'store/Library/actions'
import { fetchFiles } from 'store/Library/actions'
import ViewNote from './ViewNote'
import FileLink from './FileLink'

import { getItemIcon } from '../fileTypes'
import { useState } from 'react'
const LibItem = (props) => {
  const { item } = props
  const language = props.language || {}
  const dispatch = useDispatch()
  const [showNoteModal, setShowNoteModal] = useState(false)

  const handleItemClick = (e, item) => {
    if (item.is_note === 1) {
      e.preventDefault()
      setShowNoteModal(true)
    } else if (item.type === 'folder') {
      e.preventDefault()
      dispatch(fetchFiles(item.id))
    }
    // For other items, let the default link behavior happen
  }

  const renderNoteIcon = () => (
    <div
      className='book-image-wrapper folder-item'
      onClick={(e) => handleItemClick(e, item)}
    >
      <FontAwesomeIcon className='text-primary' icon={faStickyNote} size='5x' />
    </div>
  )

  const renderNoteIconToggled = () => (
    <div
      className='book-image-wrapper-toggled folder-item d-flex align-items-center justify-content-center'
      onClick={(e) => handleItemClick(e, item)}
      style={{ cursor: 'pointer' }}
    >
      <FontAwesomeIcon className='text-primary' icon={faStickyNote} size='5x' />
    </div>
  )

  return (
    <div
      key={item.id}
      className={props.gridView ? 'col-6 col-sm-4 col-md-3' : 'col-12'}
    >
      {props.gridView ? (
        <Card className='book-item content-box'>
          {props.userAccess === 1 ? (
            <Link
              to={`/library/${item.id}/edit`}
              className='btn btn-info btn-sm course-edit-btn'
            >
              <FontAwesomeIcon icon={faEdit} />
              <span>{language.general ? language.general.edit : null}</span>
            </Link>
          ) : null}
          {item.type && item.type === 'folder' ? (
            item.thumb ? (
              <div
                onClick={() => dispatch(fetchFiles(item.id))}
                className='book-image-wrapper'
                style={{
                  backgroundImage: `url(${item.thumb || item.path})`,
                  backgroundSize: 'cover',
                  cursor: 'pointer',
                }}
              ></div>
            ) : (
              <div
                onClick={() => dispatch(fetchFiles(item.id))}
                className='book-image-wrapper folder-item'
              >
                <FontAwesomeIcon
                  className='text-info'
                  icon={faFolder}
                  size='5x'
                />
              </div>
            )
          ) : item.is_note === 1 ? (
            // Handle notes - show note icon and open modal on click
            item.thumb ? (
              <div
                onClick={(e) => handleItemClick(e, item)}
                className='book-image-wrapper'
                style={{
                  backgroundImage: `url(${item.thumb || item.path})`,
                  backgroundSize: 'cover',
                  cursor: 'pointer',
                }}
              ></div>
            ) : (
              renderNoteIcon()
            )
          ) : (
            <FileLink item={item}>
              {item.thumb ? (
                <div
                  className='book-image-wrapper'
                  style={{
                    backgroundImage: `url(${item.thumb || item.path})`,
                    backgroundSize: 'cover',
                  }}
                ></div>
              ) : (
                <div className='book-image-wrapper no-thumb-files'>
                  <div>
                    <FontAwesomeIcon
                      icon={getItemIcon(item)}
                      size='5x'
                      className='text-info'
                    />
                  </div>
                </div>
              )}
            </FileLink>
          )}

          {item?.type === 'folder' ? (
            <div
              className='book-footer'
              onClick={() => dispatch(fetchFiles(item?.id))}
              style={{ cursor: 'pointer' }}
            >
              <CardFooter className='py-2 text-center'>
                <h5 className='mt-2' title={item?.name}>
                  {item?.name}
                </h5>
              </CardFooter>
            </div>
          ) : item.is_note === 1 ? (
            <div
              className='book-footer'
              onClick={(e) => handleItemClick(e, item)}
              style={{ cursor: 'pointer' }}
            >
              <CardFooter className='py-2 text-center'>
                <h5 className='mt-2' title={item?.name}>
                  {item?.name}
                </h5>
              </CardFooter>
            </div>
          ) : (
            <FileLink item={item} className='book-footer'>
              <CardFooter className='py-2 text-center'>
                <h5 className='mt-2' title={item?.name}>
                  {item?.name}
                </h5>
              </CardFooter>
            </FileLink>
          )}
        </Card>
      ) : (
        <Card className='shadow'>
          <CardBody className='pl-0 py-0'>
            <Row className='align-items-center '>
              <Col className='col-sm-4 col-md-2 p-0 border-right'>
                {item.type && item.type === 'folder' ? (
                  item.thumb ? (
                    <div
                      onClick={() => dispatch(fetchFiles(item.id))}
                      className='book-image-wrapper-toggled'
                      style={{
                        backgroundImage: `url(${item.thumb || item.path})`,
                        backgroundSize: 'cover',
                        cursor: 'pointer',
                      }}
                    ></div>
                  ) : (
                    <div
                      onClick={() => dispatch(fetchFiles(item.id))}
                      className='book-image-wrapper-toggled folder-item'
                    >
                      <FontAwesomeIcon
                        className='text-info'
                        icon={faFolder}
                        size='5x'
                      />
                    </div>
                  )
                ) : item.is_note === 1 ? (
                  // Handle notes in list view
                  item.thumb ? (
                    <div
                      onClick={(e) => handleItemClick(e, item)}
                      className='book-image-wrapper-toggled'
                      style={{
                        backgroundImage: `url(${item.thumb || item.path})`,
                        backgroundSize: 'cover',
                        cursor: 'pointer',
                      }}
                    ></div>
                  ) : (
                    renderNoteIconToggled()
                  )
                ) : (
                  <FileLink item={item}>
                    {item.thumb ? (
                      <div
                        className='book-image-wrapper-toggled'
                        style={{
                          backgroundImage: `url(${item.thumb || item.path})`,
                          backgroundSize: 'cover',
                        }}
                      ></div>
                    ) : (
                      <div className='book-image-wrapper-toggled no-thumb-files'>
                        <div>
                          <FontAwesomeIcon
                            icon={getItemIcon(item)}
                            size='5x'
                            className='text-info'
                          />
                        </div>
                      </div>
                    )}
                  </FileLink>
                )}
              </Col>
              <div className='ml-2 mt-3 col align-self-start'>
                {item.is_note === 1 ? (
                  <div
                    onClick={(e) => handleItemClick(e, item)}
                    className='book-footer'
                    style={{ cursor: 'pointer' }}
                  >
                    <h4 className='' title={item.name}>
                      {item.name}
                    </h4>
                  </div>
                ) : item.type === 'folder' ? (
                  <div
                    className='book-footer'
                    onClick={() => dispatch(fetchFiles(item.id))}
                    style={{ cursor: 'pointer' }}
                  >
                    <h4 className='' title={item.name}>
                      {item.name}
                    </h4>
                  </div>
                ) : (
                  <FileLink item={item} className='book-footer'>
                    <h4 className='' title={item.name}>
                      {item.name}
                    </h4>
                  </FileLink>
                )}
              </div>
              {props.userAccess === 1 && (
                <Col className='col-auto'>
                  <Link to={`/library/${item.id}/edit`}>
                    <Button
                      className='btn-icon-only ml-2 edit-item-button'
                      color='info'
                      type='button'
                      outline
                      size='sm'
                    >
                      <span className='btn-inner--icon'>
                        <FontAwesomeIcon icon={faEdit} />
                      </span>
                    </Button>
                  </Link>
                  <Button
                    className='btn-icon-only ml-2 edit-item-button'
                    color='danger'
                    onClick={() => dispatch(deleteFile(item.id))}
                    type='button'
                    outline
                    size='sm'
                  >
                    <span className='btn-inner--icon'>
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </span>
                  </Button>
                </Col>
              )}
            </Row>
          </CardBody>
        </Card>
      )}

      {/* Note Modal */}
      <ViewNote
        isOpen={showNoteModal}
        toggle={() => setShowNoteModal(false)}
        note={item}
        language={language}
      />
    </div>
  )
}

export default LibItem
